/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from ".";

const BASE_URL = "/v1/admin/saved_report_queries";

export const fetchSavedReportQueries = async ({ reportType, contextId, search, page, perPage }) => {
  const response = await api.get(BASE_URL, {
    params: {
      report_type: reportType,
      context_id: contextId,
      search: search || undefined,
      page,
      per_page: perPage,
    },
  });
  return { data: response?.data || [], totalCount: Number(response?.headers?.["total-count"] || 0) };
};

export const createSavedReportQuery = async (payload) => {
  const response = await api.post(BASE_URL, payload);
  return response?.data;
};

export const updateSavedReportQuery = async ({ id, ...payload }) => {
  const response = await api.put(`${BASE_URL}/${id}`, payload);
  return response?.data;
};

export const deleteSavedReportQuery = async (id) => {
  const response = await api.delete(`${BASE_URL}/${id}`);
  return response?.data;
};
